import React, { useCallback, useContext, useState } from 'react'
import { AssessmentResultsTrackingStyles } from './Style'
import { BarLine, AffiliationsHeader, assessmentResultsTrackingHooks, LearningCentersHeader, SegmentationDoughnut } from '.'
import { AssessmentResultsTrackingContext, learningCenterOptions, learningCenters, orderBtns, profileBtns } from './AssessmentResultsTrackingContext'
import { SystemReviewContext } from '../SystemReviewContext'
import affiliationGroups from 'keys/affiliationGroups'
import { CircularProgress } from '@mui/material'
import { AutoComplete, Button, IconButtons } from 'components/Form'
import { IconButtonGroups } from 'styles/GlobalStyle'
import { RatingChips } from 'components/Rating'
import { BarLineStyles } from '../Style'
import NumberAxis from '../NumberAxis'
import { useSelector } from 'react-redux'

const AssessmentsStatus = () => {
    const { setOrder, order, data: affiliations, lcBreakdown, layout, setLayout, profileType, setProfileType } = useContext(AssessmentResultsTrackingContext)
    const { draftAssessmentFilters } = useContext(SystemReviewContext)
    const isLearningCenter = draftAssessmentFilters?.group?.name === affiliationGroups.learningCenters
    const allSegmentTypeOptions = assessmentResultsTrackingHooks.useSegmentTypeOptions({ isLearningCenter })
    const segmentationFilter = assessmentResultsTrackingHooks.useSegmentationFilter()
    const { brokenDisplay } = useSelector(state => state.general)

    return (
        <AssessmentResultsTrackingStyles>
            <div className='filters-header'>
                <AffiliationsHeader description={" מוצגים נתוני הקריאה של "} Context={AssessmentResultsTrackingContext} />
            </div>
            <BarLineStyles>
                <div className='bar-lines-header'>
                    <div className='bar-line-filters'>
                        <div className='compare-label'>{"בהשוואה בין"}</div>
                        <div>
                            <IconButtonGroups>
                                <IconButtons
                                    btns={orderBtns}
                                    setSelected={(e, val) => setOrder(val)}
                                    selected={order}
                                />
                            </IconButtonGroups>
                        </div>
                    </div>
                    <div className='bar-line-filters'>
                        <div className='flex'>
                            <div className='left-section'>
                                <AutoComplete
                                    minWidth={180}
                                    width={180}
                                    placeholder="בחר השוואה"
                                    options={allSegmentTypeOptions}
                                    input={{
                                        value: layout,
                                        onChange: setLayout
                                    }}
                                />
                            </div>
                            <div className='select-segmentation'>
                                <AutoComplete {...segmentationFilter} />
                            </div>
                        </div>
                        <div className='profiles'>
                            <RatingChips type={profileType} />
                            <IconButtonGroups>
                                <IconButtons
                                    btns={profileBtns}
                                    setSelected={(e, val) => setProfileType(val)}
                                    selected={profileType}
                                />
                            </IconButtonGroups>
                        </div>
                    </div>
                </div>
                <div className="bar-line-container">
                    {affiliations.data ?
                        affiliations.data.length ?
                            affiliations.data?.map((affiliation, index) =>
                                affiliation.test_taker_execution_count ?
                                    <div className='bar-item-and-label'>
                                        <div>
                                            <div className='space1' />
                                            <div className='wrap-layout-label left-section'>
                                                <div className={`${brokenDisplay && (layout?.id == "class" || layout?.id =="affiliation")&& 'blurred2'} layout-label`}>
                                                    {affiliation?.name}
                                                </div>
                                                <i class="fa-thin fa-arrow-left-long chevron-icon"></i>
                                            </div>
                                        </div>
                                        <BarLine
                                            {...affiliation}
                                            lineIndex={index}
                                            lcBreakdown={lcBreakdown?.data ? (lcBreakdown.data[affiliation.id] || {}) : undefined}
                                        />
                                    </div> : <></>

                            )
                            :
                            <div className='affiliations-loading'>{"אין תוצאות לסינון זה"}</div>
                        :
                        <div className='affiliations-loading'>
                            <CircularProgress color="thirdly" />
                        </div>
                    }
                </div>
            </BarLineStyles>
            <NumberAxis />
        </AssessmentResultsTrackingStyles>
    )
}

export default AssessmentsStatus